module.exports = __webpack_public_path__ + "static/filborg_flute_enthralling_performance_mtg_clb-a7a67e7f1a3930d2cab8f43a1253e7c7.jpg";